<template>

  <el-form label-position="left" label-width="auto" size="small">
    <el-collapse :accordion="true">
      <chart-title :element="element"></chart-title>
      <chart-sub-title :element="element"></chart-sub-title>
      <el-collapse-item title="绘制" name="绘制">
        <el-form-item label="文本-显示">
          <el-switch v-model="ele.option.series[0].detail.show" active-color="#55aaff"
                     inactive-color="#ff557f">
          </el-switch>
        </el-form-item>

        <el-form-item label="文本-字体大小">
          <el-slider v-model="ele.option.series[0].detail.fontSize" :min="16" :max="50">
          </el-slider>
        </el-form-item>

        <el-form-item label="最小值">
          <el-input-number v-model="ele.option.series[0].min"></el-input-number>
        </el-form-item>

        <el-form-item label="最大值">
          <el-input-number v-model="ele.option.series[0].max"></el-input-number>
        </el-form-item>

        <el-divider></el-divider>

        <el-form-item label="起始角度">
          <el-slider v-model="ele.option.series[0].startAngle" :min="90" :max="270"></el-slider>
        </el-form-item>

        <el-form-item label="结束角度">
          <el-slider v-model="ele.option.series[0].endAngle" :min="-90" :max="90"></el-slider>
        </el-form-item>

        <el-form-item label="外层线宽">
          <el-slider v-model="ele.option.series[0].axisLine.lineStyle.width" :min="0" :max="30">
          </el-slider>
        </el-form-item>

        <el-divider></el-divider>

        <el-form-item label="颜色 0.25">
          <el-color-picker v-model="ele.option.series[0].axisLine.lineStyle.color[0][1]"
                           show-alpha
                           :predefine="['rgba(255, 255, 255, 1.0)','#ff4500',  '#ff8c00',  '#ffd700', '#90ee90',  '#00ced1', '#1e90ff',  '#c71585',  'rgba(255, 69, 0, 0.68)',  'rgb(255, 120, 0)',  'hsv(51, 100, 98)', 'hsva(120, 40, 94, 0.5)', 'hsl(181, 100%, 37%)', 'hsla(209, 100%, 56%, 0.73)','#c7158577']">
          </el-color-picker>
        </el-form-item>

        <el-form-item label="颜色 0.5">
          <el-color-picker v-model="ele.option.series[0].axisLine.lineStyle.color[1][1]"
                           show-alpha
                           :predefine="['rgba(255, 255, 255, 1.0)','#ff4500',  '#ff8c00',  '#ffd700', '#90ee90',  '#00ced1', '#1e90ff',  '#c71585',  'rgba(255, 69, 0, 0.68)',  'rgb(255, 120, 0)',  'hsv(51, 100, 98)', 'hsva(120, 40, 94, 0.5)', 'hsl(181, 100%, 37%)', 'hsla(209, 100%, 56%, 0.73)','#c7158577']">
          </el-color-picker>
        </el-form-item>

        <el-form-item label="颜色 0.75">
          <el-color-picker v-model="ele.option.series[0].axisLine.lineStyle.color[2][1]"
                           show-alpha
                           :predefine="['rgba(255, 255, 255, 1.0)','#ff4500',  '#ff8c00',  '#ffd700', '#90ee90',  '#00ced1', '#1e90ff',  '#c71585',  'rgba(255, 69, 0, 0.68)',  'rgb(255, 120, 0)',  'hsv(51, 100, 98)', 'hsva(120, 40, 94, 0.5)', 'hsl(181, 100%, 37%)', 'hsla(209, 100%, 56%, 0.73)','#c7158577']">
          </el-color-picker>
        </el-form-item>

        <el-form-item label="颜色 1.0">
          <el-color-picker v-model="ele.option.series[0].axisLine.lineStyle.color[3][1]"
                           show-alpha
                           :predefine="['rgba(255, 255, 255, 1.0)','#ff4500',  '#ff8c00',  '#ffd700', '#90ee90',  '#00ced1', '#1e90ff',  '#c71585',  'rgba(255, 69, 0, 0.68)',  'rgb(255, 120, 0)',  'hsv(51, 100, 98)', 'hsva(120, 40, 94, 0.5)', 'hsl(181, 100%, 37%)', 'hsla(209, 100%, 56%, 0.73)','#c7158577']">
          </el-color-picker>
        </el-form-item>

        <el-divider></el-divider>

        <el-form-item label="刻度间距">
          <el-slider v-model="ele.option.series[0].splitNumber" :min="0" :max="10"></el-slider>
        </el-form-item>

        <el-form-item label="刻度-长度">
          <el-slider v-model="ele.option.series[0].axisTick.length" :min="0" :max="30">
          </el-slider>
        </el-form-item>

        <el-form-item label="长刻度-长度">
          <el-slider v-model="ele.option.series[0].splitLine.length" :min="0" :max="30">
          </el-slider>
        </el-form-item>

        <el-form-item label="刻度-宽度">
          <el-slider v-model="ele.option.series[0].axisTick.lineStyle.width" :min="0" :max="30">
          </el-slider>
        </el-form-item>

        <el-form-item label="长刻度-宽度">
          <el-slider v-model="ele.option.series[0].splitLine.lineStyle.width" :min="0" :max="30">
          </el-slider>
        </el-form-item>

        <el-divider></el-divider>

        <el-form-item label="指针-长度">
          <el-input v-model="ele.option.series[0].pointer.length" :min="0" :max="100"></el-input>
        </el-form-item>

        <el-form-item label="指针-宽度">
          <el-slider v-model="ele.option.series[0].pointer.width" :min="0" :max="30"></el-slider>
        </el-form-item>
      </el-collapse-item>
    </el-collapse>
  </el-form>

</template>

<script>
import ChartTitle from "@/components/design-report/chart/chartStyle/chartTitle.vue";
import ChartSubTitle from "@/components/design-report/chart/chartStyle/chartSubTitle.vue";

export default {
  components: {   ChartSubTitle, ChartTitle},
  props: {
    element: {
      type: Object,
      default: () => {
      }
    },
    report: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      ele: null
    }
  },
  created() {
    this.ele = this.element;
  },
  methods: {
  }


}

</script>

<style scoped lang="scss">

</style>